export default __webpack_public_path__ + "static/media/room1-MASK-wood-rot25.3fdb9fc5.png";